import GetLessonByIdRequestModelBase from '../_generated/modelBases/get-lesson-by-id-request-model-base';

export default class GetLessonByIdRequestModel extends GetLessonByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
